<template lang="html">
  <section class="auth">
    <div class="input-container">
      <v-text-field
        v-model="authtoken"
        :type="'password'"
        label="DEUS Tool Authentication Token"
      ></v-text-field>
    </div>
    <v-btn
      class="button-container"
      :disabled="authtoken.length < 1"
      @click="setDeusTokenHandler()"
      @keyup.enter="setDeusTokenHandler()"
    >
      OK
    </v-btn>

    <div class="input-container">
      <v-text-field
        v-model="authTokenIotF"
        :type="'password'"
        label="IoT Flag Authentication Token"
      ></v-text-field>
    </div>
    <v-btn
      class="button-container"
      :disabled="authTokenIotF.length < 1"
      @click="setIoTFlagTokenHandler()"
      @keyup.enter="setIoTFlagTokenHandler()"
    >
      OK
    </v-btn>
  </section>
</template>

<script lang="js">
import { store } from "../store/index";

export default {
  name: "AuthView",
  data: () => ({
    authtoken: "",
    authTokenIotF: "",
  }),
  methods: {
    updateAuthToken() {
      store.commit("UPDATE_AUTH_TOKEN", this.authtoken);
    },
    updateAuthIoTFlagToken() {
      store.commit("UPDATE_IOT_FLAG_AUTH_TOKEN", this.authTokenIotF);
    },
    setDeusTokenHandler() {
      this.updateAuthToken();
      this.$router.push("/rules");
    },
    setIoTFlagTokenHandler() {
      this.updateAuthIoTFlagToken();
      this.$router.push("/iot-rules");
    },
  },
};
</script>

<style scoped>
.auth {
  background-color: #fff;
  margin: 0 auto;
  padding: 1rem;
  width: 100%;
}
</style>
